<div>
  @for (rate of arr; track rate; let i = $index) {
    <img src="/assets/images/genetics/star{{i + 1 > rating ? '' : '_rate'}}.svg">
  }
</div>
